import { defineNuxtPlugin, useUserStore } from '#imports'
import { watch } from 'vue'

import { useIsWebview } from '@backmarket/nuxt-module-navigation/useIsWebview'

import { updateUserContext } from '../utils/tracking/updateUserContext'

export default defineNuxtPlugin(() => {
  const { isUserFetched } = useUserStore()

  // Skip user context updates inside a mobile webview — the native app owns
  // the user context there, same gate as the didomi tracking plugin.
  // The gate is checked inside the callback (not at plugin init) so it
  // reflects the route meta after redirectIfWebview middleware has resolved.
  watch(
    isUserFetched,
    () => {
      if (isUserFetched.value && !useIsWebview()) {
        updateUserContext()
      }
    },
    { immediate: true },
  )
})
